import React from 'react';
import PropTypes from 'prop-types';
import { Title, Dot, InternalGrid, Box } from '@paygreen/paygreen-ui';
import { IsMobile } from '../../utils/tools';

/**
 * @description this component is based on Title component from PG-UI and will be rendered by default as `<h1>`
 */
const H1Title = ({
    title,
    children,
    marginBottom,
    textSize,
    htmlTag,
    colorWab,
}) => (
    <>
        {children ? (
            <InternalGrid
                flexWrap="wrap"
                alignItems="center"
                justifyContent="flex-start"
                hasStaticWidth={false}
                displayType={IsMobile() ? 'grid' : 'flex'}
                justifyItems="start"
            >
                <Title
                    htmlTag={htmlTag}
                    textSize={textSize}
                    colorWab={colorWab}
                    marginBottom={marginBottom}
                >
                    {title}
                </Title>

                {!IsMobile() && (
                    <Dot
                        dotStyle="dash"
                        colorPallet="wab"
                        colorWab="grey10"
                        marginBottom="md"
                        marginRight="md"
                        marginLeft="md"
                        style={{ transform: 'rotate(90deg)' }}
                    />
                )}

                <Box marginBottom="sm">{children}</Box>
            </InternalGrid>
        ) : (
            <Title
                htmlTag={htmlTag}
                textSize={textSize}
                colorWab={colorWab}
                marginBottom={marginBottom}
            >
                {title}
            </Title>
        )}
    </>
);

H1Title.propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    title: PropTypes.string,
    textSize: PropTypes.string,
    htmlTag: PropTypes.string,
    marginBottom: PropTypes.string,
    colorWab: PropTypes.string,
};

H1Title.defaultProps = {
    marginBottom: 'xs',
    textSize: 'lg',
    htmlTag: 'h1',
    colorWab: 'grey30',
};

export default H1Title;
